module.exports = __webpack_public_path__ + "static/media/share-banner-new.f4de825d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture/share-banner-new.png
// module id = 548
// module chunks = 6